module.exports = __webpack_public_path__ + "static/img/65.fa915fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/65.png
// module id = qbDw
// module chunks = 1